export const news = [
    {
        id: 2,
        slug: 'blagodarnost',
        title: '',
        description: 'Благодарим наших Партнëров за помощь в реализации наших проектов!',
        image: require('@/assets/tech1.png'),
        images: [
            require('@/assets/tech1.png'),
            require('@/assets/tech2.png')
        ],
        date: '2026-05-27',
        category: '',
        content: 'Благодарим наших Партнёров за помощь в реализации наших проектов! Консультация по телефону:\n' +
            '<a href="tel:+79230033874">8(923) 003 38 74</a>\n' +
            'Шмонина Марина',
    },
    {
        id: 3,
        slug: 'malenkije-radosty',
        title: 'Проект «Маленькие радости»: создаем настоящий дом для детей в Топчихинском центре помощи',
        description: '',
        image: require('@/assets/kids.webp'),
        date: '07-07-2026',
        category: 'Проект',
        content: '<p>Полное описание проекта...</p>',
        link: '/projects/malenkije-radosty'
    },
    {
        id: 4,
        slug: 'poezdka-v-topchihinskiy-centr-pomoshchi-detyam',
        title: 'Наша поездка в КГБУ "Топчихинский центр помощи детям"',
        description: 'Видео о нашей поездке в КГБУ "Топчихинский центр помощи детям".',
        video: require('@/assets/far.mp4'),
        date: '07-07-2026',
        category: 'Новости',
    }
]